import thorIcon from "~/assets/thor-icon-color.png";

export const topData = {
  categories: [
    {
      icon: thorIcon,
      name: "ThorChads",
      isVerified: true,
      price: {
        rune: 1549,
        usd: 175516,
        floor: 797,
      },
    },
    {
      icon: thorIcon,
      name: "ThorChads",
      isVerified: true,
      price: {
        rune: 1549,
        usd: 175516,
        floor: 797,
      },
    },
    {
      icon: thorIcon,
      name: "ThorChads",
      isVerified: true,
      price: {
        rune: 1549,
        usd: 175516,
        floor: 797,
      },
    },
    {
      icon: thorIcon,
      name: "ThorChads",
      isVerified: true,
      price: {
        rune: 1549,
        usd: 175516,
        floor: 797,
      },
    },
    {
      icon: thorIcon,
      name: "ThorChads",
      isVerified: true,
      price: {
        rune: 1549,
        usd: 175516,
        floor: 797,
      },
    },
  ],
};
